import { Component } from '@angular/core';
import { AccountItemsVouchersComponent } from 'libs/shared/src/lib/component/account-items/account-items-vouchers.component';

@Component({ standalone: false, selector: 'app-account-items-vouchers', templateUrl: './account-items-vouchers.component.html' })
export class CustomAccountItemsVouchersComponent extends AccountItemsVouchersComponent {}
